import React, {
  RefObject,
} from 'react';
import clsx from 'clsx';
import {
  CautionPanel,
  TitleDescriptionItem,
} from 'views/EMR/components/PCC/Walkthrough/components/ContentPrimitives';
import PageIntroduction from 'views/EMR/components/PCC/Walkthrough/components/PageIntroduction';
import type {
  PricingPageDefinition,
} from 'views/EMR/components/PCC/Walkthrough/types';

type Props = {
  page: PricingPageDefinition;
  headingRef: RefObject<HTMLHeadingElement | null>;
};

export default function PricingPage({
  page,
  headingRef,
}: Props) {
  return (
    <div className="flex flex-col gap-7">
      <PageIntroduction
        eyebrow={page.introduction.eyebrow}
        heading={page.introduction.heading}
        description={page.introduction.description}
        headingRef={headingRef}
      />

      <div className="flex flex-col gap-7 lg:flex-row">
        <div className="flex flex-[3] flex-col gap-[22px] rounded-2xl border border-[#E2E8F0] bg-white p-5 sm:p-7">
          {[page.collections.insurance, page.collections.patient].map((bar) => (
            <div key={bar.label} className="flex flex-col gap-2.5">
              <div className="text-[15px] font-semibold text-[#0F1B2D]">
                {bar.label}
              </div>
              <div className="flex h-14 overflow-hidden rounded-[10px]">
                {bar.segments.map((segment) => (
                  <div
                    key={segment.text}
                    style={{ width: `${segment.percent}%` }}
                    className={clsx(
                      'box-border flex items-center px-4 text-[15px] font-bold text-white',
                      segment.tone === 'primary' ? 'bg-brand-500' : 'bg-brand-700',
                    )}
                  >
                    {segment.text}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-[2] flex-col justify-center gap-5">
          {page.highlights.map((highlight) => (
            <TitleDescriptionItem
              key={highlight.title}
              title={highlight.title}
              description={highlight.description}
              iconKey={highlight.iconKey}
              iconVariant="none"
              classes={{
                title: 'text-base font-bold',
                description: 'text-sm leading-normal',
              }}
            />
          ))}
        </div>
      </div>

      <CautionPanel sections={page.cautions} />
    </div>
  );
}
